import router from "./router";
import axios from "axios";
import store from "./store";
import { Toast } from "vant";
import { login } from "./api/user";

router.beforeEach((to, from, next) => {
  const param = to.query;

  if (to.meta.requireAuth) {
    axios.get((process.env.NODE_ENV === "development" ? "/api" : "") + "/loginVerify.htm").then(
      res => {
        next();
      },
      err => {
        console.log("err permission", err);
        next({ path: "/login", query: { originPath: to.fullPath } });
        store.commit("RESET_STATE");
        Toast.fail("请登录");
      }
    );
  }

  if (param.userInfo) {
    const userInfo = JSON.parse(window.atob(decodeURIComponent(param.userInfo)));
    delete param.userInfo;
    // 调登录
    login({
      code: sessionStorage.getItem("code"),
      customer_id: userInfo.customer_id,
      customer_userid: userInfo.customer_userid,
    }).then(res => {
      if (res.data.code === 1000) {
        if (!res.data.data.rov) {
          this.$toast.fail("服务器授权信息未配置，某些功能不可用");
          next({ path: "/login", param: param });
        } else {
          if (userInfo.originPath) {
            next({ path: userInfo.originPath, param: param });
          } else {
            next({ path: to.path, params: param });
          }
        }
      } else if (res.data.code === 2000) {
        this.$toast.fail(res.data.message);
      }
      store.commit("setLoginUser", res.data.data);
    });
    return;
  }

  if (param.code) {
    store.commit("code", param.code);
    sessionStorage.setItem("code", param.code);
  }

  if (param.from === "XCX") {
    // 调登录
    login({
      customer_id: param.customerId,
      customer_userid: param.customerUserid,
    }).then(res => {
      alert(res.data.data.rov);

      if (res.data.code === 1000) {
        if (!res.data.data.rov || !res.data.data.token) {
          Toast.fail("服务器授权信息未配置，某些功能不可用");
        }
      } else if (res.data.code === 2000) {
        Toast.fail(res.data.message);
      }
      store.commit("setLoginUser", res.data.data);
      next();
    });
  } else {
    next();
  }
});
